<template lang="pug">
SspLayout(area="core")
  .header-actions(slot="actions")
    router-link.btn.btn-primary.ban-ip-button(:to="{name: 'ban'}") Ban IP
  .banned-ips-ct
    DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" url-page-param="page")
      tr(slot="thead")
        th IP address
        th Ban issued
        th Ban expires
        th Reason
        th
      tr(v-for="b in ipBans")
        td {{b.ip}}
        td {{b.issued | date}}
        td {{b.expires | date}}
        td {{b.reason}}
        td.text-center
          a.btn-restore(title="Unban" @click="unbanIp(b.ip)" style="cursor:pointer")

</template>
<script>
import miniToastr from 'mini-toastr'
import DataGrid from '@/components/ssp/DataGrid'
import Security from '@/service/apis/Security'
import { dateFilter } from '@/filters/filters'

export default {
  data: () => ({
    ipBans: []
  }),
  methods: {
    fetchData(page) {
      return Security.listIpBans(page.maxOffsetRequest())
        .then((resp) => {
          this.ipBans = resp.data.ipBans
          return resp.data.totalRecords
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    unbanIp(ip) {
      Security.unBanIp(ip)
        .then(() => {
          miniToastr.success(`${ip} was unbanned`)
          this.fetchData()
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    }
  },
  components: {
    DataGrid
  },
  filters: {
    date: dateFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/system/BannedIPs.vue